// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/ushv-mkc/document-mappings.yaml
// Run: bun run scripts/mappings/ushv-mkc-make-mappings-from-yaml.ts
import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const USHV_MKC_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed",
      "If Sig Req'd, assign to Provider, label: {{ dateReceived }} Patient Forms Sig Req'd"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "Return to Work Letter request, documents to be signed by non provider staff",
    documentLabel: "{{ dateReceived }} Patient Forms",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN,
    group: "ushv-mkc"
  },
  [Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Certificate of Medical Necessity",
    documentLabel: "{{ dateReceived }} Certificate of Medical Necessity",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY,
    group: "ushv-mkc"
  },
  [Classification.ADMIN_DEATH_CERTIFICATES]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Death/Expired report",
    documentLabel: "{{ dateReceived }} Death Report",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DEATH_CERTIFICATES,
    group: "ushv-mkc"
  },
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark High Priority"
    ],
    assignedTo: "Zalocha,Angelina",
    displayName: "Disability Paperwork, FMLA paperwork",
    documentLabel: "{{ dateReceived }} Medical Records Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "ushv-mkc"
  },
  [Classification.ADMIN_PATIENT_QUESTIONNAIRE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "Patient Questionnaires",
    documentLabel: "{{ dateReceived }} Patient Questionnaire",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_PATIENT_QUESTIONNAIRE,
    group: "ushv-mkc"
  },
  [Classification.ADMIN_TRANSITION_CARE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Transition of care (TDC)",
    documentLabel: "{{ dateReceived }} Transition of Care",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_TRANSITION_CARE,
    group: "ushv-mkc"
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark High Priority"
    ],
    assignedTo: "Provider's MA",
    displayName: "Cardiac Clearance Request/ Anesthesia / Pre-anesthesia Request",
    documentLabel: "{{ dateReceived }} Cardiac Clearance Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "ushv-mkc"
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "If Type = Stockings, assign to Jennings,Faith, label: {{dateReceived}} Stockings Rx"
    ],
    assignedTo: "Provider",
    displayName: "DME Order",
    documentLabel: "{{dateReceived}} DME Order",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "ushv-mkc"
  },
  [Classification.FINANCIAL_BILLING_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Anitha.Paladugu@usheartandvascular.com"
    ],
    assignedTo: null,
    displayName: "Billing documents",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.FINANCIAL_BILLING_RECORDS,
    group: "ushv-mkc"
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "ID/DL/Passport",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IDENTIFICATION_CARD,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Leg Images",
    documentLabel: "{{ dateOfEvent }} Cardiac Leg Images",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_COLONOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Colonoscopy Report",
    documentLabel: "{{ dateOfEvent }} Colonoscopy",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_COLONOSCOPY,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "CT scans",
    documentLabel: "{{ dateOfEvent }} CT",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_ECHO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Echocardiogram Reports",
    documentLabel: "{{ dateOfEvent }} Echo",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ECHO,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_EKG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "ECG/EKG",
    documentLabel: "{{ dateOfEvent }} EKG",
    folder: "EKG",
    folderMapping: "EKG",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EKG,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_ENDOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Endoscopy Report",
    documentLabel: "{{ dateOfEvent }} Endoscopy",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ENDOSCOPY,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_HOLTER_MONITOR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Holter Event Monitor reports",
    documentLabel: "{{ dateOfEvent }} Monitor Report",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_HOLTER_MONITOR,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_MAMMOGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Mammogram Report",
    documentLabel: "{{ dateOfEvent }} Mammogram",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MAMMOGRAM,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_MONITOR_NOTIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "ACS No Transmission Notification",
    documentLabel: "{{ dateReceived }} Monitor Notification",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MONITOR_NOTIFICATION,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "CMR Report Radiology Report",
    documentLabel: "{{ dateOfEvent }} MRI",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_NM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Nuclear Scans",
    documentLabel: "{{ dateOfEvent }} Nuclear",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_NM,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_PET]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Myocardial Perfusion (PET CT)",
    documentLabel: "{{ dateOfEvent }} PET",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_PET,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Exercise Treadmill Test Report",
    documentLabel: "{{ dateOfEvent }} Stress Test",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Ultrasound Report, Any Type (Abdominal, etc.)",
    documentLabel: "{{ dateOfEvent }} Ultrasound",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "ushv-mkc"
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "X-Rays",
    documentLabel: "{{ dateOfEvent }} XR",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "ushv-mkc"
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "Insurance cards",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "ushv-mkc"
  },
  [Classification.INTAKE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "Patient Demographics",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INTAKE,
    group: "ushv-mkc"
  },
  [Classification.JUNK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Ads, blank pages, etc.",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.JUNK,
    group: "ushv-mkc"
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Lab results",
    documentLabel: "{{collectionDate}} Labs",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "ushv-mkc"
  },
  [Classification.LAB_RESULTS_BP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "BP Logs",
    documentLabel: "{{collectionDate}} BP Log",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_BP,
    group: "ushv-mkc"
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Pathology/Biopsy reports & Alere Home Monitoring",
    documentLabel: "{{collectionDate}} Path/Biopsy",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "ushv-mkc"
  },
  [Classification.LAB_RESULTS_PT_INR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider's nurse",
    displayName: "PT/INR",
    documentLabel: "{{collectionDate}} PT-INR",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PT_INR,
    group: "ushv-mkc"
  },
  [Classification.LAB_RESULTS_QUANTAFLO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Quanta Flo",
    documentLabel: "{{collectionDate}} Quanta Flo",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_QUANTAFLO,
    group: "ushv-mkc"
  },
  [Classification.LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "POA's (Power of Attorney), Arbitration forms (Timestamp & Review)",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL,
    group: "ushv-mkc"
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Non-USHV Clinic Notes",
    documentLabel: "{{ dateOfEvent }} Clinic Notes",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC,
    group: "ushv-mkc"
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Hospital/Other Dr's Consult/Progress Notes",
    documentLabel: "{{ dateOfEvent }} Hospital Notes",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL,
    group: "ushv-mkc"
  },
  [Classification.MEDICAL_HISTORY_HOME_HEALTH]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "HomeHealth Service/Physician Order",
    documentLabel: "{{ dateOfEvent }} HomeHealth Service/Order",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_HOME_HEALTH,
    group: "ushv-mkc"
  },
  [Classification.MEDICAL_HISTORY_MEDICATIONS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "Medication List",
    documentLabel: "{{dateReceived}} Medications - Vaccines",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_MEDICATIONS,
    group: "ushv-mkc"
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Datavant,Staff",
    displayName: "Medical records Release/Request",
    documentLabel: "{{ dateReceived }} Medical Records Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    priority: "{{schedulingPriority}}",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "ushv-mkc"
  },
  [Classification.MEDICAL_RECORD_REQUEST_HEDIS]: {
    accountFirstName: null,
    accountId: "3232298",
    accountLastName: null,
    additionalWorkflow: [
      "Upload to account 3232298"
    ],
    assignedTo: "Datavant,Staff",
    displayName: "Medical records requests for multiple patients",
    documentLabel: "{{ dateReceived }} Medical Records Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST_HEDIS,
    group: "ushv-mkc"
  },
  [Classification.NOTIFICATION_HOSPITAL_DISCHARGE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "Hospital Discharge notes/Instructions",
    documentLabel: "{{ dateOfEvent }} Hospital Discharge Notification",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_DISCHARGE,
    group: "ushv-mkc"
  },
  [Classification.ORDER_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Cupid Order Note",
    documentLabel: "{{ dateReceived }} Cardiac Order",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_CARDIAC,
    group: "ushv-mkc"
  },
  [Classification.ORDER_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider's PSR",
    displayName: "Unsupported CPT for Imaging Orders",
    documentLabel: "{{dateReceived}} CPT Needed",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_CLARIFICATION,
    group: "ushv-mkc"
  },
  [Classification.ORDER_FROM_PHYSICIAN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark High Priority"
    ],
    assignedTo: "Provider",
    displayName: "Physician Attestation (a document stating that a provider performed a surgery)",
    documentLabel: "{{ dateReceived }} Physician Attestation",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_FROM_PHYSICIAN,
    group: "ushv-mkc"
  },
  [Classification.ORDER_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Imaging Orders",
    documentLabel: "{{ dateReceived }} Imaging Orders",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_IMAGING,
    group: "ushv-mkc"
  },
  [Classification.ORDER_LAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Lab orders",
    documentLabel: "{{dateReceived}} Lab Order",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_LAB,
    group: "ushv-mkc"
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "All other documents",
    documentLabel: "{{ dateReceived }} Patient Forms",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.OTHER,
    group: "ushv-mkc"
  },
  [Classification.PHARMACY_RELATED_ALERT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider's MA",
    displayName: "Medication Alerts/Advisories/Therapeutic Alerts",
    documentLabel: "{{ dateReceived }} RX Therapeutic Alert",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_ALERT,
    group: "ushv-mkc"
  },
  [Classification.PHARMACY_RELATED_CARE_CONSIDERATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider's MA",
    displayName: "Medication Considerations",
    documentLabel: "{{ dateReceived }} Care Consideration",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CARE_CONSIDERATION,
    group: "ushv-mkc"
  },
  [Classification.PHARMACY_RELATED_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider's MA",
    displayName: "Prescriber Response Form",
    documentLabel: "{{ dateReceived }} RX Response Form",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CLARIFICATION,
    group: "ushv-mkc"
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider's MA",
    displayName: "Refill Authorization Requests",
    documentLabel: "{{ dateReceived }} RX Refill Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "ushv-mkc"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider's MA",
    displayName: "Prior Authorization Requests (for Prescriptions specifically)",
    documentLabel: "{{ dateReceived }} Prior Auth Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "ushv-mkc"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider's MA",
    displayName: "Prior Authorization Approval/Denial (for Prescriptions specifically)",
    documentLabel: "{{ dateReceived }} Prior Auth {{ authorizationStatus }}",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "ushv-mkc"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Prior Authorization Requests for Procedures",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "ushv-mkc"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Prior Authorization Approval/Denial (for procedures/imaging specifically)",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "ushv-mkc"
  },
  [Classification.PROCEDURE_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Cath Diagram, Heart Cath Hospital Notes / Diagram",
    documentLabel: "{{ dateOfEvent }} Cardiac Report",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC,
    group: "ushv-mkc"
  },
  [Classification.PROCEDURE_CARDIAC_VEIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "Venous Questionnaires",
    documentLabel: "{{ dateReceived }} Venous Questionnaire",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC_VEIN,
    group: "ushv-mkc"
  },
  [Classification.PROCEDURE_DEVICE_INFO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Mark reviewed",
      "If Type = ICD, assign to Provider"
    ],
    assignedTo: "Jennings,Faith",
    displayName: "Implant Registration/Info/Card",
    documentLabel: "{{ dateReceived }} Device Info",
    folder: "Device Interrogations",
    folderMapping: "Device Interrogations",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_DEVICE_INFO,
    group: "ushv-mkc"
  },
  [Classification.PROCEDURE_DEVICE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Weiss,Sara OR Leblanc,Alexandra",
    displayName: "Device/Implantables Transfer Request",
    documentLabel: "{{ dateReceived }} Device Transfer Request",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_DEVICE_REQUEST,
    group: "ushv-mkc"
  },
  [Classification.PROCEDURE_REHAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Cardiac Rehab",
    documentLabel: "{{ dateOfEvent }} Cardiac Rehab",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_REHAB,
    group: "ushv-mkc"
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Sleep Study Reports",
    documentLabel: "{{ dateOfEvent }} Sleep Report",
    folder: "Non-Cardiovascular Imaging",
    folderMapping: "Non-Cardiovascular Imaging",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_SLEEP,
    group: "ushv-mkc"
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Non-USHV Progress Notes",
    documentLabel: "{{ dateOfEvent }} Progress Notes",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE,
    group: "ushv-mkc"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Inpatient Discharge Summary Report",
    documentLabel: "{{ dateOfEvent }} Hospital Discharge Summary",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY,
    group: "ushv-mkc"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "H&P Notes",
    documentLabel: "{{ dateOfEvent }} HP Notes",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_RECORDS,
    group: "ushv-mkc"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider",
    displayName: "Summary of Care",
    documentLabel: "{{ dateOfEvent }} Hospital Summary of Care",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY,
    group: "ushv-mkc"
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "If Type = ICD, upload to Device Interrogations"
    ],
    assignedTo: "Provider",
    displayName: "OP Reports",
    documentLabel: "{{ dateOfEvent }} Op Report",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "ushv-mkc"
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Referral Coordinators",
    displayName: "Patient Referrals",
    documentLabel: "{{dateOfReferral}} Referral Order",
    folder: "Referral Documents",
    folderMapping: "Referral Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.REFERRAL,
    group: "ushv-mkc"
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider's MA",
    displayName: "Referral responses",
    documentLabel: "{{ dateReceived }} Referral Response",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_RESPONSE,
    group: "ushv-mkc"
  }
} as const;
